import _mapValues from "lodash/mapValues";

export const px = (value) => `${value}px`;
export const pxify = (values) => {
  return _mapValues(values, px);
};
